import { Typography } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { EnumSelectField } from '@mews-commander/form';
import {
    PortfolioEnterpriseProductServiceProductData,
    PortfolioProductOptions,
    PortfolioPromotions,
} from '@mews-commander/data-access';
import { ServicesFieldNames } from '../../../forms/schemas/configureProductFormSchema';
import { buildNestedFieldName } from '../../helpers';
import { useProductOptions } from '../../../../hooks/useProductOptions';

interface ServicesAvailabilityProps extends Pick<PortfolioEnterpriseProductServiceProductData, 'bookablePeriod'> {
    currentService?: string;
}

export const ServicesAvailability = ({ currentService, bookablePeriod }: ServicesAvailabilityProps) => {
    const filteredProductOptions = useProductOptions({ currentService, bookablePeriod });
    const optionsFieldName = buildNestedFieldName(ServicesFieldNames.Options, currentService);
    const promotionsFieldName = buildNestedFieldName(ServicesFieldNames.Promotions, currentService);

    return (
        <>
            <Typography textStyle="bodyLargeStrong" as="div">
                {lt('ConfigureProductServicesSubHeadingAvailability')}
            </Typography>
            <EnumSelectField
                name={optionsFieldName}
                enumClass={PortfolioProductOptions}
                enabledValues={filteredProductOptions}
                enumPrefix="ProductOptions"
                label={lt('ProductOptions')}
                omitHint
                multiselect
            />
            <EnumSelectField
                name={promotionsFieldName}
                label={lt('ConfigureProductServicesPromotions')}
                enumClass={PortfolioPromotions}
                enumPrefix="Promotions"
                multiselect
                omitHint
            />
        </>
    );
};
